import { _LAYOUT_NAME } from '@/enums/LayoutName';
import { _ROUTER_NAME } from '@/enums/RouterName';
import { _MODAL_TYPE } from '@/enums/ModalType';

export { _LAYOUT_NAME, _ROUTER_NAME, _MODAL_TYPE };
